import { Component, OnInit, Input } from '@angular/core';

import { SharedTrainedListService } from './shared-trained-list.service';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-shared-trained-list',
    templateUrl: './shared-trained-list.component.html',
    styleUrls: ['./shared-trained-list.component.scss'],
})
export class SharedTrainedListComponent implements OnInit {
    @Input() departmentType: any;
    @Input() registerType: any;

    capacitationTitle: string;

    /* Paginação */
    perPage: number = 10;
    page: number = 1;
    total: number = 0;
    /** Pesquisa */
    search: string = '';
    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any[];

    onInputChange$ = new Subject<string>();

    destroy$ = new Subject();

    constructor(private sharedTrainedListService: SharedTrainedListService) {}

    ngOnInit(): void {
        this.capacitationTitle = this.registerType == 1 ? 'Professores Graduados' : 'Árbitros certificados';
        this.trainedList();
        this.onInputChange$.pipe(debounceTime(300), takeUntil(this.destroy$)).subscribe((term) => {
            this.search = term;
            this.trainedList();
        });
    }

    /**
     * trainedList() - Buscar lista de registros registrados e capacitados
     */
    trainedList() {
        this.sharedTrainedListService
            .getTrainedList(this.departmentType, this.registerType, this.page, this.perPage, this.search)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (returnSuccess) => {
                    this.successCallbackApi(returnSuccess);
                },
                (returnFail) => {
                    this.errorCallbackServer(returnFail);
                }
            );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers;
        this.total = response.meta.total;
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
    }

    onPageChange(pageNumber) {
        this.page = pageNumber;
        this.trainedList();
    }

    ngOnDestroy() {
        this.destroy$.next();
    }
}
